import { NoddiDurationPicker } from 'noddi-ui-web';
import { type DurationPreset, useDebounceValue } from 'noddi-util';
import { useEffect, useState } from 'react';
import { useWheelSetNotMovedForDays, WHEEL_SET_NOT_MOVED_DEFAULT_DAYS } from './useWheelSetNotMovedForDays';

const DAY_SECONDS = 86_400;

const PRESETS: DurationPreset[] = [
  { label: '3 months', seconds: 90 * DAY_SECONDS },
  { label: '6 months', seconds: 180 * DAY_SECONDS },
  { label: '1 year', seconds: WHEEL_SET_NOT_MOVED_DEFAULT_DAYS * DAY_SECONDS }
];

export const WheelSetNotMovedForPicker = () => {
  const [days, setDays] = useWheelSetNotMovedForDays();
  // The issue list reloads on every change: send it what was typed once typing pauses, not each keystroke.
  const [draftDays, setDraftDays] = useState(days);
  const debouncedDays = useDebounceValue({ value: draftDays, delay: 500 });
  useEffect(() => {
    if (debouncedDays !== days) {
      setDays(debouncedDays);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- fires on the debounced draft only; days/setDays would re-send a stale draft after a URL change
  }, [debouncedDays]);
  // A URL change from elsewhere (back button, a link) replaces the draft.
  const [syncedDays, setSyncedDays] = useState(days);
  if (syncedDays !== days) {
    setSyncedDays(days);
    setDraftDays(days);
  }
  return (
    <NoddiDurationPicker
      label='Not moved for'
      tooltip='Wheel sets at the facility whose last movement is older than this. Label prints and detail edits do not count as movement.'
      value={draftDays * DAY_SECONDS}
      onChange={(seconds) => setDraftDays(Math.max(1, Math.round(seconds / DAY_SECONDS)))}
      units={['d']}
      presets={PRESETS}
      min={DAY_SECONDS}
      className='w-fit'
    />
  );
};
